export class EnvironmentFileNotConfiguredException extends Error {}
